import { ModalType } from '../../types';
import { CreateActionParams } from '../actions';

export type showModal = <T>(type: ModalType, props?: T) => void;

export function createShowModalAction({
  context,
  getControllerState,
}: CreateActionParams): showModal {
  return (type, props) => {
    const [, setState] = getControllerState();

    setState({ modalContext: { type, props } });
  };
}
